var exports = {
  "k": "x0a7806d5--e14d4d--container",
};

module.exports = exports;
